import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.incident-anlegen-aus-funkprotokoll';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentAnlegenAusFunkprotokollEffects {

    IncidentAnlegenAusFunkprotokoll$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_INCIDENT_ANLEGEN_AUS_FUNKPROTOKOLL),
        mergeMap((x: ac.PostIncidentAnlegenAusFunkprotokollAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postIncidentAnlegenAusFunkprotokoll(x.incidentFunkprotokollRequest).pipe(
                map((result: any) => {
                    return new ac.PostIncidentAnlegenAusFunkprotokollErfolgreichAction(result, x.incidentFunkprotokollRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostIncidentAnlegenAusFunkprotokollFehlerAction(error, x.incidentFunkprotokollRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
